module.exports = __webpack_public_path__ + "media/images/OPL 77-8c60b906c2b461c52ae5403997ffa3f7.png";